// MS50 #3001 / MS54 §8.2 — reusable "auto-submit" Stimulus controller.
//
// CSP-safe replacement for the inline `onchange="this.form.submit()"` handler.
// The enforcing nonce CSP (script-src :self + nonce, no unsafe_inline — #1222)
// blocks inline event handlers, which silently left change-driven toggles dead.
// Wire the change-driven control with `data-action="change->auto-submit#submit"`
// and put `data-controller="auto-submit"` on the enclosing <form>; a change then
// submits the form via the standards-based requestSubmit() (which fires form
// validation + the Turbo submit lifecycle, unlike the older form.submit()).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
